import React from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Button from '@material-ui/core/Button';

import LoadingIndicator from '../LoadingIndicator';
import FormItemContainer from '../Global/Containers/FormItemContainer';

import combineStyles from '../../utils/combineStyles';
import ButtonStyles from '../../styles/button';
import TypographyStyles from '../../styles/typography';

export const DefaultLocation = ({
  t,
  classes,
  isLoading,
  defaultLocation,
  onEditLocation
}) => {
  return (
    <FormItemContainer
      title={t('Default Location')}
      secondaryAction={
        <Button
          size={'small'}
          color={'primary'}
          className={classnames(classes.smallButton, classes.actionButtons)}
          classes={{
            label: classes.buttonLabel
          }}
          onClick={onEditLocation}
        >
          {t('Edit')}
        </Button>
      }
    >
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <div>
          <p className={classes.body2}>
            {defaultLocation.name || 'No location selected'}
          </p>
          <p className={classes.body2}>
            {defaultLocation.id ? defaultLocation.address.address1 : null}
          </p>
          <p className={classes.body2}>
            {defaultLocation.id ? defaultLocation.address.address2 : null}
          </p>
          <p className={classes.body2}>
            {defaultLocation.id
              ? defaultLocation.address.city +
                ', ' +
                defaultLocation.address.state +
                ' ' +
                defaultLocation.address.postalCode
              : null}
          </p>
        </div>
      )}
    </FormItemContainer>
  );
};

export default withStyles(combineStyles(ButtonStyles, TypographyStyles))(
  withNamespaces()(DefaultLocation)
);
